import React from "react";
import { ToDateJalali } from "../../../../Common/Function";

function ClassInfo({ user, userDetails }) {
  return (
    <>
      <div className="row p-4">
        <div className="row">
          <h5>اطلاعات شما</h5>
        </div>
        <div className="row mt-2 ">
          {userDetails.map((item, count) => {
            return (
              <div key={count} className="col-md-6">
                <label htmlFor="">{item.label} :</label>
                <input
                  className="form-control mt-1"
                  type="text"
                  placeholder={
                    user && user[item.id] ? user[item.id] : "ثبت نشده"
                  }
                />
              </div>
            );
          })}
        </div>
      </div>
      <hr className="mt-3" />
    </>
  );
}

export default ClassInfo;